import {CancelToken} from "axios";
import {ApiMethods, ApiServiceController, IApiExecutor} from "../../../../../../@bizkeytech/base/core";
import ApiEndpoints from "../../endpoints";
import * as models from "./index.types";

/**@inheritDoc*/
export class SettingController extends ApiServiceController {

    /**@inheritDoc*/
    public constructor(executor: IApiExecutor | undefined) {
        super(executor);
    }

    /**
     * Get the configuration of the site from the server.
     *
     * @param cancelToken       The abort controller that will be used to cancel the request.
     */
    public async getPartnerSetting(cancelToken?: CancelToken): models.GetPartnerSettingResponse {
        return this.executor?.execute({
            method: ApiMethods.get,
            url: ApiEndpoints.setting.getPartnerSetting,
            cancelToken: cancelToken,
            showErrorToast: false,
        });
    }

    /**
     * Get the configuration of the site from the server.
     *
     * @param authorizationToken    The token that will be used to authenticate the request.
     * @param cancelToken       The abort controller that will be used to cancel the request.
     */
    public async getPartnerColorTheme(authorizationToken: string, cancelToken?: CancelToken): models.GetPartnerSettingResponse {
        return this.executor?.execute({
            method: ApiMethods.get,
            url: ApiEndpoints.setting.getPartnerSetting,
            cancelToken: cancelToken,
            headers: {
                Authorization: authorizationToken,
            },
        });
    }

}

export * from './index.types';
export default SettingController;
